<template>
  <div>
    <v-card class="px-6">
      <v-toolbar color="#2f5578" dark>
        <v-toolbar-title>
          {{ isEdit ? 'Edit' : 'Add' }} Link Permission
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pb-0 px-2 mb-3">
        <ValidationObserver ref="observer" v-slot="{ validate, reset }">
          <v-form v-model="valid" lazyValidation>
            <v-layout row wrap class="px-0">
              <v-flex class="px-2" xs12 sm6>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Menu Title"
                  rules="required"
                >
                  <v-select
                    v-model="permission.title"
                    :items="routeOptions"
                    item-text="title"
                    item-value="title"
                    label="Menu Title"
                    name="Menu Title"
                    @change="handleChange"
                    :readonly="isEdit"
                  ></v-select>
                </ValidationProvider>
              </v-flex>
              <v-flex class="px-2" xs12 sm6>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="linkGroup"
                  rules="required"
                >
                  <v-text-field
                    v-model="permission.menuItem"
                    label="Link Group"
                    name="linkGroup"
                    readonly
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex class="px-2" xs12 sm6>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Route"
                  rules="required"
                >
                  <v-text-field
                    v-model="permission.route"
                    name="Route"
                    label="Route"
                    :error-messages="errors"
                    readonly
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex class="px-2" xs12 sm6>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="icon"
                  rules="required"
                >
                  <v-text-field
                    v-model="permission.icon"
                    :append-icon="permission.icon"
                    name="icon"
                    label="Icon"
                    :error-messages="errors"
                    readonly
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <!-- <v-flex class="px-2" xs12 v-if="permission.permissions">
                <span class="caption">Permission Groups: </span>
                <v-layout row wrap class="well px-2 pb-2">
                  <v-flex v-for="(item, index) in permission.permissions" :key="index">
                    <v-checkbox
                      style="text-transform: capitalize"
                      v-model="item.grant"
                      :name="item.group.groupName"
                      :label="item.group.groupName"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-flex> -->
              <v-flex class="px-2" xs12 sm12>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="linkGroup"
                  rules="required"
                >
                  <v-select
                    :items="authGroupItems"
                    v-model="permission.authGroups"
                    label="Auth Group"
                    name="linkGroup"
                    chips
                    multiple
                  ></v-select>
                </ValidationProvider>
              </v-flex>
            </v-layout>
          </v-form>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <div class="px-3 pb-3">
          <v-btn v-if="isEdit" color="error" medium @click="onDelete()">
            Delete
          </v-btn>
        </div>
        <v-spacer></v-spacer>
        <div class="px-3 pb-3">
          <v-btn color="primary" medium @click="save()">Save</v-btn>
          <v-btn medium @click="close()">Close</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import menuItems from './menuItems';
import MenuPermission from '@/models/MenuPermission';
import { mapMenuPermissionsFields } from '@/store/modules/menuPermissions';

export default {
  name: 'PermissionLevelDialog',
  props: {
    selected: {
      type: Object,
    },
    isEdit: {
      type: Boolean,
    },
    menuPermission: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      valid: true,
      groupOptions: ['Dealer', 'Maintain', 'Misc'],
      permission: new MenuPermission(),
      routeOptions: menuItems,
      authGroupItems: [
        'Dealer',
        'DealerManagers',
        'Helpdesk',
        'Administrators',
      ],
    };
  },
  computed: {
    ...mapMenuPermissionsFields(['permissionSet']),
  },
  methods: {
    handleChange(data) {
      let vm = this;
      const menu = this.routeOptions.filter(e => e.title == data);
      if (!vm.isEdit && data) {
        if (menu.length) {
          vm.permission.menuItem = menu[0].group;
          vm.permission.route = menu[0].route;
          vm.permission.icon = menu[0].icon;
          vm.permission.authGroups = menu[0].authGroup;
        }
      }
    },
    close() {
      this.$emit('close', false);
      this.reset();
    },
    save() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          let payload = new MenuPermission(this.permission);
          this.$emit('save', payload);
          this.reset();
        }
      });
    },
    onDelete() {
      this.$emit('onDelete', this.permission);
      this.reset();
    },
    reset() {
      this.$refs.observer.reset();
      this.permission = new MenuPermission(this.permissionSet);
    },
  },
  watch: {
    menuPermission(val) {
      this.permission = new MenuPermission(val);

      if (val.id != 0) {
        this.permission.type = this.routeOptions
          .filter(x => x.title == val.menuItem)
          .map(x => x.group)[0];
      }
    },
  },
};
</script>
